export default __webpack_public_path__ + "static/media/deleteIcon.d65509ce.svg";